/* eslint-disable no-restricted-imports */

import { Box, IconButton, Typography } from '@material-ui/core';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';

import PropTypes from 'prop-types';

import { useStyles } from './styles';

export default function PageHeader({ onBack, title, subtitle, rightContent }) {
  const classes = useStyles();

  return (
    <Box className={classes.header}>
      <Box className={classes.headerLeft}>
        {onBack && (
          <IconButton onClick={onBack} className={classes.backButton}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Box>
          <Typography variant='h5' className={classes.title}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant='body2' color='textSecondary'>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {rightContent && <Box>{rightContent}</Box>}
    </Box>
  );
}

PageHeader.propTypes = {
  onBack: PropTypes.func,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  rightContent: PropTypes.node,
};
